import { useMemo } from 'react';

export interface PricelessFilterItem {
  id: string;
  hasPriceData: boolean;
}

export interface PricelessFilterState {
  pricelessCount: number;
  allPriceless: boolean;
  showToggle: boolean;
  shouldIncludePriceless: boolean;
  visibleIds: string[];
}

export const usePricelessFilter = (items: PricelessFilterItem[], showPriceless: boolean): PricelessFilterState => {
  return useMemo(() => {
    const pricelessCount = items.filter((item) => !item.hasPriceData).length;
    const allPriceless = pricelessCount > 0 && pricelessCount === items.length;
    const shouldIncludePriceless = showPriceless || allPriceless;

    return {
      pricelessCount,
      allPriceless,
      showToggle: pricelessCount > 0 && !allPriceless,
      shouldIncludePriceless,
      visibleIds: items.filter((item) => item.hasPriceData || shouldIncludePriceless).map((item) => item.id),
    };
  }, [items, showPriceless]);
};
